<template>
  <section class="bg6 p-t-35 p-b-10" style="padding-right: 12px">
    <div v-if="loading" class="loading-overlay">
      <img src="../assets/images/login/loader_ebh.gif" style="width: 10%" />
      <p style="font-size: 20px; font-weight: 500">Loading...</p>
    </div>
    <div v-else class="container">
      <div class="row">
        <div
          class="col-12 col-md-12 col-lg-8 text-left"
          style="margin-bottom: 0px !important"
        >
          <div
            class="bg1000 p-all-15 m-b-10 p-lr-15-sm cl0"
            style="border-radius: 10px"
          >
            <h4 class="stext-110">
              <i class="fa fa-info-circle"></i> Pemesanan anda hampir selesai!
            </h4>
            <p>
              Pilih cara termudah anda untuk melakukan transaksi dengan berbagai
              pilihan
            </p>
            <small
              >Periksa kembali sebelum melanjutkan ke proses berikutnya</small
            >
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <br class="d-md-none" />

          <div class="card-pengiriman">
            <span
              class="mt-2"
              v-b-modal.modal-1
              @change="cekHargaRajaCepat"
              style="
                color: #000;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 18px; /* 112.5% */
                letter-spacing: -0.16px;
              "
            >
              <span
                style="
                  stroke-width: 1px;
                  stroke: var(--primary-05, #244786);
                  width: 24px;
                  height: 13.389px;
                "
                @change="cekHargaRajaCepat"
                v-b-modal.modal-1
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="16"
                  viewBox="0 0 26 16"
                  fill="none"
                >
                  <path
                    d="M17.2786 11.903L16.7961 11.7719L16.7786 11.8363V11.903H17.2786ZM19.9474 2.07609L20.4299 2.20713L20.4474 2.14279L20.4474 2.07612L19.9474 2.07609ZM19.1718 1.30535V1.80539L19.1778 1.80532L19.1718 1.30535ZM7.58884 1.30535L7.58883 1.80535H7.58884V1.30535ZM6.81786 2.07609L7.30491 2.18914L7.31752 2.13481L7.31785 2.07903L6.81786 2.07609ZM4.53684 11.903L4.04979 11.7899L4.03684 11.8457V11.903H4.53684ZM16.9158 12.6737L16.4359 12.5334L16.2486 13.1737H16.9158V12.6737ZM19.2059 4.84214V4.34214H18.8312L18.726 4.70181L19.2059 4.84214ZM22.9709 4.84214V5.34214L22.972 5.34214L22.9709 4.84214ZM23.2687 4.97803L23.7022 4.72891L23.6787 4.68812L23.6481 4.65241L23.2687 4.97803ZM24.9084 7.83164L24.4749 8.08075L24.5001 8.12469L24.5337 8.16268L24.9084 7.83164ZM25 8.0717L25.4746 8.229L25.5003 8.15151L25.5 8.06988L25 8.0717ZM23.4748 12.6737V13.1737H23.8358L23.9494 12.831L23.4748 12.6737ZM10.0947 4.07898C10.3709 4.07898 10.5947 3.85512 10.5947 3.57898C10.5947 3.30284 10.3709 3.07898 10.0947 3.07898V4.07898ZM2.76842 3.07898C2.49228 3.07898 2.26842 3.30284 2.26842 3.57898C2.26842 3.85512 2.49228 4.07898 2.76842 4.07898V3.07898ZM8.57895 6.35267C8.85509 6.35267 9.07895 6.12881 9.07895 5.85267C9.07895 5.57652 8.85509 5.35267 8.57895 5.35267V6.35267ZM3.52632 5.35267C3.25017 5.35267 3.02632 5.57652 3.02632 5.85267C3.02632 6.12881 3.25017 6.35267 3.52632 6.35267V5.35267ZM9.33684 9.13161C9.61298 9.13161 9.83684 8.90776 9.83684 8.63161C9.83684 8.35547 9.61298 8.13161 9.33684 8.13161V9.13161ZM1 8.13161C0.723858 8.13161 0.5 8.35547 0.5 8.63161C0.5 8.90776 0.723858 9.13161 1 9.13161V8.13161ZM9.44558 13.1737H16.5122V12.1737H9.44558V13.1737ZM16.5122 13.1737C16.8489 13.1737 17.1714 13.0392 17.4086 12.8005L16.6996 12.0954C16.6494 12.1459 16.5819 12.1737 16.5122 12.1737V13.1737ZM17.4086 12.8005C17.6458 12.562 17.7786 12.2391 17.7786 11.903H16.7786C16.7786 11.9757 16.7498 12.0449 16.6996 12.0954L17.4086 12.8005ZM17.7611 12.034L20.4299 2.20713L19.4648 1.94505L16.7961 11.7719L17.7611 12.034ZM20.4474 2.07612C20.4474 1.90836 20.4143 1.74219 20.3499 1.58723L19.4264 1.97078C19.4402 2.00404 19.4474 2.03984 19.4474 2.07605L20.4474 2.07612ZM20.3499 1.58723C20.2856 1.43227 20.1912 1.29151 20.0721 1.17317L19.3672 1.88248C19.3924 1.90753 19.4126 1.93751 19.4264 1.97078L20.3499 1.58723ZM20.0721 1.17317C19.953 1.05484 19.8116 0.961294 19.656 0.898106L19.2798 1.82463C19.3123 1.83782 19.3420 1.85743 19.3672 1.88248L20.0721 1.17317ZM19.656 0.898106C19.5004 0.834915 19.3338 0.803377 19.1658 0.805388L19.1778 1.80532C19.2127 1.8049 19.2473 1.81144 19.2798 1.82463L19.656 0.898106ZM19.1718 0.805352H7.58884V1.80535H19.1718V0.805352ZM7.58885 0.805352C7.25216 0.805347 6.92971 0.939353 6.69178 1.1772L7.39877 1.88442C7.44976 1.83345 7.51814 1.80535 7.58883 1.80535L7.58885 0.805352ZM6.69178 1.1772C6.45395 1.41496 6.31984 1.73712 6.31786 2.07315L7.31785 2.07903C7.31828 2.00539 7.34769 1.93549 7.39877 1.88442L6.69178 1.1772ZM6.3308 1.96304L4.04979 11.7899L5.02389 12.016L7.30491 2.18914L6.33080 1.96304ZM4.03684 11.903C4.03684 12.2391 4.16959 12.5620 4.40678 12.8005L5.11587 12.0954C5.06559 12.0449 5.03684 11.9757 5.03684 11.9030H4.03684ZM4.40678 12.8005C4.64406 13.0392 4.96648 13.1737 5.30326 13.1737V12.1737C5.23351 12.1737 5.16605 12.1459 5.11587 12.0954L4.40678 12.8005ZM5.30326 13.1737H6.29778V12.1737H5.30326V13.1737ZM18.5051 12.1737H16.9158V13.1737H18.5051V12.1737ZM17.3957 12.8141L19.6858 4.98248L18.7260 4.70181L16.4359 12.5334L17.3957 12.8141ZM19.2059 5.34214H22.9709V4.34214H19.2059V5.34214ZM22.9720 5.34214C22.9568 5.34217 22.9416 5.33893 22.9274 5.33244L23.3426 4.42272C23.2255 4.36928 23.0983 4.34185 22.9698 4.34214L22.9720 5.34214ZM22.9274 5.33244C22.9131 5.32594 22.9000 5.31624 22.8892 5.30365L23.6481 4.65241C23.5640 4.55442 23.4597 4.47615 23.3426 4.42272L22.9274 5.33244ZM22.8351 5.22714L24.4749 8.08075L25.3419 7.58253L23.7022 4.72891L22.8351 5.22714ZM24.5337 8.16268C24.5126 8.13877 24.5001 8.10717 24.5 8.07353L25.5 8.06988C25.4992 7.85961 25.4217 7.65753 25.2831 7.5006L24.5337 8.16268ZM24.5254 7.9144L23.0001 12.5164L23.9494 12.8310L25.4746 8.2290L24.5254 7.9144ZM23.4748 12.1737H21.8259V13.1737H23.4748V12.1737ZM9.08947 13.0527C9.08947 13.6834 8.57814 14.1948 7.94737 14.1948V15.1948C9.13042 15.1948 10.0895 14.2357 10.0895 13.0527H9.08947ZM7.94737 14.1948C7.31660 14.1948 6.80526 13.6834 6.80526 13.0527H5.80526C5.80526 14.2357 6.76432 15.1948 7.94737 15.1948V14.1948ZM6.80526 13.0527C6.80526 12.4219 7.31660 11.9106 7.94737 11.9106V10.9106C6.76432 10.9106 5.80526 11.8696 5.80526 13.0527H6.80526ZM7.94737 11.9106C8.57814 11.9106 9.08947 12.4219 9.08947 13.0527H10.0895C10.0895 11.8696 9.13042 10.9106 7.94737 10.9106V11.9106ZM21.4684 13.0527C21.4684 13.6492 20.9361 14.1948 20.2 14.1948V15.1948C21.4173 15.1948 22.4684 14.27 22.4684 13.0527H21.4684ZM20.2 14.1948C19.4639 14.1948 18.9316 13.6492 18.9316 13.0527H17.9316C17.9316 14.27 18.9827 15.1948 20.2 15.1948V14.1948ZM18.9316 13.0527C18.9316 12.4561 19.4639 11.9106 20.2 11.9106V10.9106C18.9827 10.9106 17.9316 11.8354 17.9316 13.0527H18.9316ZM20.2 11.9106C20.9361 11.9106 21.4684 12.4561 21.4684 13.0527H22.4684C22.4684 11.8354 21.4173 10.9106 20.2 10.9106V11.9106ZM10.0947 3.07898H2.76842V4.07898H10.0947V3.07898ZM8.57895 5.35267H3.52632V6.35267H8.57895V5.35267ZM9.33684 8.13161H1V9.13161H9.33684V8.13161Z"
                    fill="#244786"
                  />
                </svg>
              </span>
              Pilih Pengiriman
            </span>
            <div
              @change="cekHargaRajaCepat"
              v-b-modal.modal-1
              class="mt-3 d-flex"
              v-if="selectedPrice"
              style="
                border: 2px solid #375fa8;
                border-radius: 10px;
                width: 100%;
                cursor: pointer;
              "
            >
              <div class="p-2">{{ selectedPrice.description }}</div>
              <div class="p-2" style="color: white">Flex item</div>
              <div class="ml-auto p-2">
                {{ formatPrice(selectedPrice.cost[0].value) }}
              </div>
            </div>

            <br />
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-12 col-lg-8 text-left"
          style="margin-bottom: 0px !important"
        >
          <div class="card-alamat mt-4">
            <div class="d-flex justify-content-between">
              <div>
                <span
                  style="
                    color: var(--primary-05, #244786);
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 18px; /* 112.5% */
                    letter-spacing: -0.16px;
                  "
                  >Alamat Pesanan Anda</span
                >
              </div>
              <div class="mt-2">
                <span
                  style="
                    color: white;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 18px; /* 112.5% */
                    letter-spacing: -0.16px;
                  "
                  >Alamat Pesanan Anda</span
                >
              </div>
              <div>
                <button
                  @click="openModal"
                  style="
                    display: flex;
                    padding: 10px 15px;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;
                    border-radius: 50px;
                    background: var(--primary-04, #3860a8);
                    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
                  "
                >
                  <div
                    style="
                      width: 16px;
                      height: 16px;
                      fill: #fff;
                      margin-top: -5px;
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.15328 12.1743L0.0402878 15.1423C-0.00245068 15.2565 -0.0114093 15.3807 0.0144821 15.4998C0.0403735 15.619 0.100021 15.7282 0.186299 15.8144C0.272578 15.9006 0.381843 15.9601 0.501043 15.9859C0.620243 16.0117 0.744342 16.0026 0.858517 15.9597L3.82566 14.8467C4.16527 14.7195 4.47372 14.5211 4.73028 14.2648L13.3251 5.67001C13.3251 5.67001 13.0252 4.77131 12.1274 3.87262C11.2295 2.97477 10.33 2.67492 10.33 2.67492L1.73519 11.2697C1.47889 11.5263 1.28048 11.8347 1.15328 12.1743ZM11.5285 1.47637L12.7 0.304934C12.91 0.0948714 13.1904 -0.0389591 13.4835 0.0101685C13.896 0.0779308 14.527 0.282912 15.1216 0.878372C15.7171 1.47383 15.9221 2.10402 15.9898 2.51653C16.039 2.8096 15.9051 3.08996 15.6951 3.30003L14.5228 4.47147C14.5228 4.47147 14.2238 3.57362 13.3251 2.67577C12.4272 1.77622 11.5285 1.47637 11.5285 1.47637Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <span
                    style="
                      color: var(--neutral-01, #fefefe);
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 15.4px; /* 110% */
                      letter-spacing: -0.14px;
                    "
                    >Pilih Alamat</span
                  >
                </button>
              </div>
            </div>

            <p
              :key="shipping.address_id"
              class="mt-3"
              style="
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 15.4px; /* 110% */
                letter-spacing: -0.14px;
              "
            >
              {{ shipping.firstname }} {{ shipping.lastname }}
            </p>
            <p
              :key="shipping.address_id"
              style="
                color: var(--neutral-06, #4c4949);
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 15.4px; /* 110% */
                letter-spacing: -0.14px;
              "
            >
              {{ shipping.address_2 }} {{ shipping.city }},
              {{ shipping.province }},
              {{ shipping.country }}
            </p>
            <p
              :key="shipping.telephone"
              style="
                color: var(--neutral-06, #4c4949);
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 15.4px; /* 110% */
                letter-spacing: -0.14px;
              "
            >
              {{ shipping.telephone }} || {{ shipping.zone_id }}
            </p>
          </div>
          <br />
          <div class="mt-3" v-for="(product, index) in products" :key="index">
            <div
              class="co-card1 mr-2"
              style="background-color: #ffc341; border-radius: 10px"
            >
              <div class="d-flex">
                <span
                  :key="product.mall_id"
                  style="
                    color: #191717;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 15.4px;
                    letter-spacing: -0.14px;
                  "
                >
                  {{ product.mall || "Tidak ada toko" }}
                </span>
              </div>
            </div>
            <div
              style="
                width: 99%;
                height: 1px;
                background: #cbcbcb;
                border-radius: 10px;
              "
            ></div>
            <div class="co-card2 mr-2" style="flex-direction: column">
              <div
                class="mt-3 d-flex"
                v-for="(subProduct, subIndex) in product.products"
                :key="subIndex"
              >
                <img
                  @click="handleProductClick(subProduct)"
                  style="width: 60px; height: 80px; margin-right: 10px"
                  :src="
                    'https://cdn.eurekabookhouse.co.id/ebh/product/all/' +
                    subProduct.image
                  "
                  alt="kartu-angka-dan-huruf-hijaiah"
                  onerror="this.src='https://stagingapi.eurekabookhouse.com/assets/front/images/eureka-bookhouse-bg-grey.jpg';"
                />
                <td>
                  <span
                    @click="handleProductClick(subProduct)"
                    style="
                      color: var(--neutral-07, #191717);
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 15.4px;
                      letter-spacing: -0.14px;
                      cursor: pointer;
                    "
                    >{{ subProduct.nama_produk }}
                  </span>

                  <div class="col-3 col-md-2 px-2 mb-2 text-center">
                    <div class="d-flex align-items-start">
                      <div class="mr-2">
                        <p
                          style="
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 18px;
                            letter-spacing: -0.16px;
                          "
                        >
                          {{ subProduct.qty }}x
                        </p>
                      </div>
                      <div class="mr-2">
                        <p
                          style="
                            color: var(--primary-04, #3860a8);
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 18px;
                            letter-spacing: -0.16px;
                          "
                        >
                          {{ formatPrice(subProduct.price) }}
                        </p>
                      </div>
                    </div>
                    <span
                      style="
                        color: var(--primary-05, #244786);
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 18px;
                        letter-spacing: -0.16px;
                      "
                      class="text-left"
                    >
                      {{ formatPrice(subProduct.total_harga) }}
                    </span>
                  </div>
                </td>
              </div>
            </div>
          </div>

          <!-- <br /> -->
          <!-- <div class="card-catatan mr-2">
            <h6 class="judul-catatan">Notes Pesanan</h6>
            <textarea
              class="mt-2"
              style="
                width: 100%;
                height: 100px;
                padding: 10px;
                border-radius: 10px;
                border: 1px solid #3860a8;
              "
              placeholder="Silahkan tulis notes anda disini"
            ></textarea>
          </div> -->
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="mt-4 card-pengiriman">
            <span
              class="mt-2"
              v-b-modal.modal-1
              @change="cekHargaRajaCepat"
              style="
                color: #000;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 18px; /* 112.5% */
                letter-spacing: -0.16px;
              "
            >
              Gunakan Voucher
            </span>
            <div class="input-group mb-3">
              <input
                v-model="couponCode"
                type="text"
                class="form-control"
                placeholder="Masukan Kode Voucher"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  @click="applyCoupon"
                  class="btn btn-outline-secondary"
                  style="background-color: #244786; color: white"
                  type="button"
                >
                  Pakai
                </button>
              </div>
            </div>
          </div>
          <div class="mt-4 card-co">
            <span
              class="mt-2"
              style="
                color: #000;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 18px; /* 112.5% */
                letter-spacing: -0.16px;
                text-align: left;
              "
            >
              Ringkasan Pesanan Anda
            </span>

            <div class="d-flex justify-content-between mt-5">
              <span
                style="
                  color: #000;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
                >Subtotal Produk</span
              ><span style="color: white">haha</span
              ><span
                style="
                  color: var(--primary-05, #244786);
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
              >
                {{ formatPrice(total.totalHarga) }}
              </span>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <span
                style="
                  color: #000;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
                >Subtotal Pengiriman</span
              ><span style="color: white">haha</span
              ><span
                v-if="selectedPrice"
                style="
                  color: var(--primary-05, #244786);
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
              >
                {{ formatPrice(selectedPrice.cost[0].value) }}
              </span>
            </div>
            <div
              v-if="selectedPrice && !isNaN(voucherRes.discount)"
              class="d-flex justify-content-between mt-3"
            >
              <span
                style="
                  color: #000;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
              >
                Voucher yang digunakan
              </span>
              <span style="color: white">haha</span>
              <span
                style="
                  color: red;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
              >
                - {{ formatPrice(voucherRes.discount) }}
              </span>
            </div>

            <div
              class="mt-2"
              style="width: 99%; height: 1px; background: #cbcbcb"
            ></div>
            <!-- <div class="d-flex justify-content-between mt-3">
              <span
                class="mt-2"
                style="
                  color: #000;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px; /* 110% */
                  letter-spacing: -0.14px;
                "
                >Voucher Anda</span
              ><span style="color: white">haha</span
              ><button
                style="
                  display: flex;
                  height: 32px;
                  padding: 15px 10px;
                  align-items: center;
                  gap: 8px;
                  border-radius: 10px;
                  background: var(--neutral-03, #cbcbcb);
                "
              >
                <span
                  style="
                    color: var(--neutral-02, #efefef);
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 13.2px; /* 110% */
                    letter-spacing: -0.12px;
                  "
                  >Tidak digunakan</span
                >
              </button>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <span
                class="mt-2"
                style="
                  color: #000;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 15.4px;
                  letter-spacing: -0.14px;
                "
                >Kupon</span
              >
              <span style="color: white">haha</span>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  style="
                    border-radius: 5px 0 0 5px;
                    background: var(--neutral-02, #efefef);
                    font-size: 11px;
                  "
                  placeholder="Tulis Kupon Anda"
                />
                <div class="input-group-append">
                  <button
                    class="btn"
                    style="
                      border-radius: 0 5px 5px 0;
                      height: 30px;
                      background: var(--primary-05, #244786);
                    "
                  >
                    <span
                      style="
                        color: var(--neutral-01, #fefefe);
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 13.2px;
                        letter-spacing: -0.12px;
                      "
                      >Gunakan</span
                    >
                  </button>
                </div>
              </div>
            </div> -->
            <div
              v-if="voucherRes.finalTotal"
              class="d-flex justify-content-between mt-4"
            >
              <span
                style="
                  color: var(--primary-04, #3860a8);
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 18px; /* 112.5% */
                  letter-spacing: -0.16px;
                "
                >Total Pesanan</span
              >
              <span style="color: white">haha</span>
              <span
                style="
                  color: var(--primary-05, #244786);
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 18px; /* 112.5% */
                  letter-spacing: -0.16px;
                "
              >
                {{ formatPrice(voucherRes.finalTotal) }}
              </span>
            </div>

            <!-- Display this div if voucherRes.finalTotal is not present -->
            <div v-else class="d-flex justify-content-between mt-4">
              <span
                style="
                  color: var(--primary-04, #3860a8);
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 18px; /* 112.5% */
                  letter-spacing: -0.16px;
                "
                >Total Pesanan</span
              >
              <span style="color: white">haha</span>
              <span
                style="
                  color: var(--primary-05, #244786);
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 18px; /* 112.5% */
                  letter-spacing: -0.16px;
                "
              >
                {{
                  formatPrice(total.totalHarga + selectedPrice.cost[0].value)
                }}
              </span>
            </div>
            <!-- <pre>{{voucherRes}}</pre> -->
            <div class="mt-3">
              <button
                @click="buatPesanan"
                style="
                  display: flex;
                  width: 100%;
                  height: 50px;
                  padding: 10px;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  align-self: stretch;
                  border-radius: 50px;
                  background: var(--primary-05, #244786);
                "
              >
                <span
                  style="
                    color: var(--neutral-01, #fefefe);
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 18px; /* 112.5% */
                    letter-spacing: -0.16px;
                  "
                  >Buat Pesanan</span
                >
              </button>
            </div>
            <br />
            <b-modal
              id="modal-1"
              title="Ubah Pengiriman"
              @show="initializeSelectedPrice"
            >
              <div
                v-for="(price, index) in rajaCepatPrices"
                :key="index"
                class="mt-3"
                style="
                  border-radius: 10px;
                  border: 2px solid #375fa8;
                  padding: 20px;
                "
              >
                <div class="row">
                  <div class="col-1 mt-3">
                    <input
                      type="radio"
                      :id="'priceRadio' + index"
                      v-model="selectedPrice"
                      :value="price"
                      style="transform: scale(1.5)"
                    />
                  </div>
                  <div class="col">
                    <b>{{ price.description }} </b>
                  </div>
                  <div class="col">{{ price.cost[0].etd }} hari</div>
                  <div class="col">{{ formatPrice(price.cost[0].value) }}</div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <b-modal
      style="padding: 0"
      v-model="modalVisible"
      title="Pilih Alamat Pengiriman"
      hide-footer
      @shown="loadFormData"
    >
      <div class="bg4 m-b-10">
        <div
          v-for="(address, index) in addressList"
          :key="index"
          class="mt-1 card m-b-5"
          style="border-radius: 15px"
        >
          <div class="card-body">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                align-self: stretch;
              "
            ></div>
            <!-- ... other HTML content ... -->
            <div
              style="border: 0.5px solid #3860a8; border-radius: 10px"
              class="d-flex flex-row"
            >
              <div class="p-2">
                <button
                  class="mr-2"
                  :class="{
                    'star-button-active': address.status === 0,
                    'star-button-inactive': address.status === 1,
                  }"
                  @click="() => editAlamatFavorite(address.address_id)"
                >
                  <span
                    style="
                      color: var(--neutral-01, #fefefe);
                      font-size: 16px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 13.2px; /* 110% */
                      letter-spacing: -0.12px;
                    "
                  >
                    <i class="fa fa-star" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
              <div class="p-2">
                <span class="title-name text-left">
                  {{ address.firstname }}
                  {{ address.lastname }}
                </span>
                <p class="text-number text-left">{{ address.telephone }}</p>
                <p class="text-alamat text-left">
                  {{ address.address_2 }}, {{ address.city }},
                  {{ address.province }}, {{ address.postcode }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import axios from "axios";
import router from "@/router";
import Swal from "sweetalert2";
import { BModal } from "bootstrap-vue";
export default {
  name: "checkoutPage",
  components: {
    BModal,
  },
  data() {
    return {
      voucherRes: {},
      couponCode: "",
      modalVisible: false,
      formData: {
        firstname: "",
        lastname: "",
        telephone: "",
        selectedProvinsi: "",
        selectedKota: "",
        selectedKecamatan: "",
        postcode: "",
        address_2: "",
      },
      showSelectPaymentButton: true,
      addressList: [], // To store the fetched list of addresses
      selectedProvinsi: "",
      selectedKota: "",
      selectedKecamatan: "",
      selectedKodePos: "",
      provinces: {},
      shipping: [],
      customer: {},
      shippingid: "",
      products: [],
      store: [],
      total: 0,
      loading: false,
      selectedShipping: "",
      selectedPrice: null,
      shippingCityId: null,
      totalWeight: null,
      rajaCepatPrices: [],
    };
  },
  methods: {
    async applyCoupon() {
      const idCustomer = localStorage.getItem("id_customer");
      const token = localStorage.getItem("token");
      const totalOrder =
        this.total.totalHarga + this.selectedPrice.cost[0].value;

      try {
        const response = await axios.post(
          "https://stagingapi.eurekabookhouse.com/coupon/apply",
          {
            customer_id: idCustomer,
            coupon_code: this.couponCode,
            total_order: totalOrder,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status.code === 200) {
          this.voucherRes = response.data.status;
          this.couponDetails = response.data.status.appliedCoupon; // Save coupon details

          Swal.fire({
            title: "Success!",
            text: "Voucher berhasil digunakan!",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#3860A8",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: response.data.status.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while applying the coupon.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    fetchCustomerDetails() {
      const idCustomer = localStorage.getItem("id_customer");
      const token = localStorage.getItem("token");
      const apiUrl = `https://stagingapi.eurekabookhouse.com/customer/detail?customer_id=${idCustomer}`;

      fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            // Save customer details to local storage
            localStorage.setItem("customer_details", JSON.stringify(data.data));

            // Set the customer data in the component
            this.customer = data.data;
          } else {
            Swal.fire({
              confirmButtonColor: "#3860A8",
              title: "Error",
              text: "Failed to fetch customer details",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching customer details: ", error);
        });
    },
    confirmPaymentSelection() {
      this.showSelectPaymentButton = false;
    },
    handleProductClick(subProduct) {
      // Dispatch an action to set the product_id in the Vuex store
      this.$store.dispatch("setProductId", subProduct.slug);

      // Navigate to the detail page with the slug as a parameter
      this.$router.push({
        name: "detailprodukPage",
        params: { slug: subProduct.slug },
      });
    },
    loadFormData() {
      // Set formData with shipping data
      this.formData.firstname = this.shipping.firstname;
      this.formData.lastname = this.shipping.lastname;
      this.formData.telephone = this.shipping.telephone;
      this.formData.address_2 = this.shipping.lastname;
      // ... continue for other fields
    },
    async editAlamatFavorite(address_id) {
      const idCustomer = localStorage.getItem("id_customer");
      const token = localStorage.getItem("token");

      const apiUrl =
        "https://stagingapi.eurekabookhouse.com/shipping/edit/alamatFavorite";
      const addressId = address_id;

      const payload = {
        customer_id: idCustomer,
        address_id: addressId,
        status: true,
      };

      try {
        const response = await axios.put(apiUrl, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Show success message using SweetAlert2
        Swal.fire({
          confirmButtonColor: "#3860A8",
          icon: "success",
          title: "Berhasil",
          confirmButtonColor: "#3860A8",
          text: "Alamat telah dijadikan favorit!",
        }).then(() => {
          this.$router.push("/cart");
          // window.location.reload();
        });
      } catch (error) {
        // Handle errors
        console.error("Error:", error);

        // Show error message using SweetAlert2
        Swal.fire({
          confirmButtonColor: "#3860A8",
          icon: "error",
          title: "Error",
          text: "Gagal menjadikan alamat sebagai favorit.",
        });
      }
    },

    async fetchAddresses() {
      try {
        const token = localStorage.getItem("token");
        const idCustomer = localStorage.getItem("id_customer");

        const response = await fetch(
          `https://stagingapi.eurekabookhouse.com/shipping/alamat?customer_id=${idCustomer}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();

        // Check if the API request was successful (you may need to adjust this based on your API response)
        if (response.ok) {
          // Update addressList with the fetched data
          this.addressList = result.data;
        } else {
          console.error("Error fetching addresses:", result.status.message);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    },

    openModal() {
      // You can also perform any necessary data setup before opening the modal
      this.modalVisible = true;
      this.getProvinces(); // Load provinces when the modal is opened, if needed
    },
    async buatPesanan() {
      try {
        this.loading = true;

        const mappedProducts = [];

        this.products.forEach((product) => {
          const mall_id = product.mall_id || 0;

          product.products.forEach((subProduct) => {
            const productId = subProduct.id_produk || 0;
            const productName = subProduct.nama_produk || "";
            const quantity = subProduct.qty || 0;
            const price = subProduct.price || 0;
            const total = subProduct.total_harga || 0;

            mappedProducts.push({
              product_id: productId,
              variation_id: 0,
              mall_id: mall_id,
              id_variasi: 0,
              name: productName,
              model: 0,
              quantity: quantity,
              price: price,
              diskon: 0,
              total: total,
              tax: 0,
              reward: 0,
              elib_borrowed_at: null,
              elib_expired_at: null,
              elib_created_at: null,
            });
          });
        });

        const token = localStorage.getItem("token");
        const idCustomer = localStorage.getItem("id_customer");

        const response = await fetch(
          "https://stagingapi.eurekabookhouse.com/order",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              shipping_postcode: this.shipping.zone_id,
              invoice_prefix: "EBH",
              no_invoice: "",
              no_faktur: "",
              mall_id: 0,
              mall_id_rajong: 0,
              berattotal: 0,
              awb: "",
              subtotal: this.total.totalHarga,
              ongkoskirim: this.selectedPrice.cost[0].value,
              freeongkir: 0,
              subtotal_final:
                this.total.totalHarga + this.selectedPrice.cost[0].value,
              store_id: 0,
              store_name: "eurekabookhouse.co.id",
              customer_id: idCustomer,
              firstname: this.shipping.firstname,
              lastname: this.shipping.lastname,
              email: this.customer.email,
              telephone: this.shipping.telephone,
              fax: "",
              payment_id: 0,
              payment_firstname: this.shipping.firstname,
              payment_lastname: this.shipping.lastname,
              payment_telephone: this.shipping.telephone,
              payment_company: "",
              payment_company_id: "",
              payment_tax_id: "",
              payment_address_1: "",
              payment_address_2: this.shipping.address_2,
              payment_city: "Jakarta Timur",
              payment_postcode: this.shipping.postcode,
              payment_country: "13750",
              payment_country_id: this.shipping.country_id,
              payment_zone: this.shipping.zone_1,
              payment_zone_id: this.shipping.zone_id,
              payment_address_format: this.shipping.address_2,
              payment_method: "",
              payment_code: "",
              shipping_id: this.shipping.address_id,
              shipping_firstname: this.shipping.firstname,
              shipping_lastname: this.shipping.lastname,
              shipping_company: "",
              shipping_address_1: "",
              shipping_address_2: this.shipping.address_2,
              shipping_city: this.shipping.city,
              // shipping_postcode: this.shipping.city,
              shipping_country: this.shipping.postcode,
              shipping_country_id: this.shipping.country_id,
              shipping_zone: this.shipping.zone_1,
              shipping_zone_id: this.shipping.zone_id,
              shipping_address_format: this.shipping.address_2,
              shipping_method: "",
              shipping_code: "",
              shipping_kurir: "",
              shipping_kurir_type: 0,
              comment: "",
              catatan_penjual: null,
              total_kupon: this.couponDetails ? this.couponDetails.amount : 0,
              total:
                this.total.totalHarga +
                this.selectedPrice.cost[0].value -
                (this.couponDetails ? this.couponDetails.amount : 0),
              order_status_id: 0,
              order_baca_id: 0,
              withdraw_status: 0,
              affiliate_id: 0,
              commission: 0,
              language_id: 0,
              currency_id: 0,
              currency_code: "IDR",
              currency_value: "100.00000000",
              ip: "",
              forwarded_ip: "",
              user_agent: "",
              accept_language: "",
              date_invoice: 0,
              date_modified: 0,
              konfirm_bayar: 0,
              source: "",
              perangkat: "web",
              invoice_no: 0,
              products: mappedProducts,
              orderTotalEntries: [
                {
                  code: "shipping",
                  title: `${this.selectedPrice.description} ${this.shipping.city}`,
                  text: "",
                  value: this.selectedPrice.cost[0].value,
                  sort_order: "3",
                },
              ],
              notify: 0,
              coupon_id: this.couponDetails ? this.couponDetails.coupon_id : 0,
              kode_kupon: this.couponDetails
                ? this.couponDetails.kode_kupon
                : "",
              amount: this.couponDetails ? this.couponDetails.amount : 0,
            }),
          }
        );

        const result = await response.json();

        if (response.ok) {
          const idOrder = result.status.idOrder;
          localStorage.setItem("selectedOrderId", idOrder);

          router.push("/pesanan");
        } else {
          console.error("Error membuat pesanan:", result.message);
        }
      } catch (error) {
        console.error("Error membuat pesanan:", error);
      } finally {
        this.loading = false;
      }
    },

    async initializeSelectedPrice() {
      // Set selectedPrice to the first item in the array when the modal is shown
      if (this.rajaCepatPrices && this.rajaCepatPrices.length > 0) {
        this.selectedPrice = this.rajaCepatPrices[0];
      }
    },
    async cekHargaRajaCepat() {
      try {
        this.loading = true;
        const token = localStorage.getItem("token");
        const idCustomer = localStorage.getItem("id_customer");

        const response = await fetch(
          "https://stagingapi.eurekabookhouse.com/shipping/cekHarga",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              muat: 153,
              bongkar: this.shippingCityId,
              berat: this.totalWeight,
            }),
          }
        );

        const result = await response.json();

        if (response.ok) {
          this.rajaCepatPrices = result.selectPrice;
          // console.log("ini harga ", this.rajaCepatPrices);
          await this.initializeSelectedPrice(); // Wait for initializeSelectedPrice to complete
          // You can handle the pricing information as needed
        } else {
          console.error("Error fetching RajaCepat prices:", result.message);
          if (result.status && result.status.code === 400) {
            // Handle specific error with code 400
            Swal.fire({
              icon: "info",
              title: "Alamat Anda Kosong !",
              confirmButtonText: "Tambah Alamat",
              confirmButtonColor: "#3860A8",
              text: "Silahkan lengkapi alamat pengiriman anda terlebih dahulu ! ",
            }).then(() => {
              // Redirect ke halaman /Users/alamat setelah klik OK pada SweetAlert
              this.$router.push("/Users/tambahalamat");
            });
          } else {
            // Handle other errors
            Swal.fire({
              confirmButtonColor: "#3860A8",
              icon: "error",
              title: "Gagal",
              text: "Terjadi kesalahan. Silakan coba lagi.",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching RajaCepat prices:", error);
        Swal.fire({
          confirmButtonColor: "#3860A8",
          icon: "error",
          title: "Gagal",
          text: "Terjadi kesalahan. Silakan coba lagi.",
        });
      } finally {
        this.loading = false; // Set loading ke false setelah pemanggilan selesai atau error
      }
    },

    formatPrice(price) {
      // Menggunakan metode ini untuk mengonversi harga ke format Rupiah (Rp) tanpa desimal
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(price);
    },
  },
  mounted() {
    // Memanggil cekHargaRajaCepat saat komponen dimuat
    this.fetchAddresses();
    this.cekHargaRajaCepat();
  },
  created() {
    this.fetchCustomerDetails();
    this.loading = true; // Set loading ke true saat komponen dibuat
    const checkoutData = JSON.parse(localStorage.getItem("checkoutData"));

    if (checkoutData) {
      this.shipping = checkoutData.data[0].shipping[0];
      this.shippingid = checkoutData.data[0].shipping[0].address_id;
      // console.log("iniii id nyaa", this.shippingid);
      this.shippingCityId = checkoutData.data[0].shipping[0].zone_id;
      this.products = checkoutData.data[1].products;
      this.total = checkoutData.data[2].total;
      this.totalWeight = checkoutData.data[2].total.totalWeight;
    }

    this.loading = false; // Set loading ke false setelah mendapatkan data
  },
};
</script>

<style>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255); /* Semi-transparent white background */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Set a high z-index to ensure it's above other elements */
}
.notif-card {
  /* display: flex; */
  max-width: 713px;
  height: 95px;
  padding: 0px 0px 64px 678px;
  /* justify-content: flex-end; */
  align-items: center;
  border-radius: 5px;
  border-radius: 5px;
  background: var(--primary-04, #3860a8);
  /* background: var(--primary-04, #3860a8); */
  /* background-image: url("../assets/images/navbar/cotema.png"); Gambar sebagai latar belakang */
}
.card-pengiriman {
  display: flex;
  max-width: 100%;
  height: 120px;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.card-co {
  /* display: flex; */
  max-width: 100%;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.card-alamat {
  /* display: flex; */
  /* max-width: 347px;
  height: 120px; */
  padding: 10px;
  /* /* flex-direction: column; */
  align-items: flex-start;
  gap: 11px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.select-pengiriman {
  display: flex;
  padding: 16px 10px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 10px;
  background: var(--primary-01, #d2e2ff);
}
.card-co {
  border-radius: 10px;
}
.co-card1 {
  display: flex;

  /* width: 775px; */
  height: 40px;
  padding: 15px;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--neutral-01, #fefefe);
}
.co-card2 {
  display: flex;
  padding: 15px;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--neutral-01, #fefefe);
}
.card-catatan {
  /* display: flex; */
  /* width: 775px; */
  padding: 15px;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.catatan {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--neutral-02, #efefef);
}
</style>
